module.exports = __webpack_public_path__ + "img/jisushishi_icon.fb2398d2.png";